<template>
  <div>
    <loading-overlay v-if="(isLoading&&!isHelpHubHost) || isCallback"></loading-overlay>
    <help-hub-header
      v-show="showValidation"
      v-if="routeMeta && routeMeta.displayHeader &&!isHelpHubHost"
      :env="appEnv"
      @onHHComponentSuccess="onHHComponentSuccess"
      @onHHComponentError="onHHComponentError"
      @onUserCountryUpdated="onUserCountryUpdated"
      :hide-search="routeMeta.hideSearch"
      :title="routeMeta.title"
      ref="header"
    ></help-hub-header>
    <div v-if="routeMeta.displayHeader &&!isHelpHubHost">
      <transition :name="validateTransition" mode="out-in">
        <router-view v-if="authResponse"></router-view>
      </transition>
    </div>
    <div v-else-if="!isHelpHubHost">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
    <modals-container />
    <help-hub-footer
      v-if="displayFooter"
      :env="appEnv"
      v-show="!isLoading&&!isCallback"
      :platform-category="platformCategory"
      ref="footerWebComponent"
    />
  </div>
</template>

<script>

import LoadingOverlay from "@/components/LoadingOverlay";
import axios from "axios/index";
import Vue from "vue";
import { mapGetters, mapMutations } from "vuex";
import * as CONSTANTS from "@/store/constants";
import api from "@/api";
import EmployeeHubRedirect from "./components/homepage/EmployeeHubRedirect";
import {safeImportComponent} from "./utils/componentImportUtils";
export default {
  name: "app",
  data() {
    return {
      appEnv: CURRENT_ENV,
      showFooter: false
    };
  },
  mounted() {
    console.log('App mounted');
  },
  computed: {
    isCallback() {
      if (this.$route.path === "/callback") {
        return true;
      }
      return false;
    },
    isHelpHubHost() {
      if (
        window.location.href === HELP_HUB_DOMAIN ||
        window.location.href === HELP_HUB_DOMAIN + "home" ||
        window.location.href === EMPLOYEE_HUB_DOMAIN ||
        window.location.href === EMPLOYEE_HUB_DOMAIN + "home"
      ) {
        window.location = ADSK_ONE_BASE_URL;
      } else {
        return false;
      }
    },
    ...mapGetters(["authResponse", "isLoading", "country", "searchReady"]),
    validateTransition() {
      return this.$route.name === "knowledge-article" ||
        this.$route.name === "knowledge-articles-by-id"
        ? ""
        : "fade";
    },
    beforeRouteEnter(to, from, next) {},
    routeMeta() {
      return this.$route.meta;
    },
    displayFooter() {
      return this.showFooter;
    },
    platformCategory() {
      if (
        this.$route &&
        this.$route.path &&
        this.$route.path.includes(`/${CONSTANTS.HR_PLATFORM}/`)
      ) {
        return CONSTANTS.HR_PLATFORM;
      } else {
        return this.$route.meta.showITAndHR ? "ALL" : CONSTANTS.IT_PLATFORM;
      }
    },
    showValidation() {
      if (
        this.$route.name === "knowledge-articles" ||
        this.$route.name === "knowledge-articles-by-id"
      ) {
        return true;
      } else {
        return !this.isLoading && !this.isCallback;
      }
    }
  },
  components: {
    EmployeeHubRedirect,
    LoadingOverlay
  },
  created() {
    this.checkIfRequestisFromSAMLError();
    // If there is no header, we can't expect an auth response so just stop loading right away
    if (!this.routeMeta.displayHeader) {
      this.setIsLoading(false);
    }
  },
  methods: {
    ...mapMutations(["setAuthResponse", "setIsLoading", "setCountry"]),
    checkIfRequestisFromSAMLError() {
      if (this.$route.query && this.$route.query.error == "access_denied") {
        this.$router.push({ name: "login-error" });
      }
    },
    onUserCountryUpdated(response) {
      if (response && response.detail) {
        this.setCountry(response.detail[0].countryPreferences);
      }
    },
    onHHComponentSuccess(response) {
      if(window.location.href!==HELP_HUB_DOMAIN && window.location.href!==HELP_HUB_DOMAIN+"home") {
        safeImportComponent(HH_COMPONENTS_URL + "/theme.css");
      }
      if (response.detail.length) {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + response.detail[0].accessToken;
        this.setAuthResponse(response.detail[0]);
      } else {
        axios.defaults.headers.common["Authorization"] = "Bearer " + response;
      }
      this.showFooter = true;
      this.setIsLoading(false);

      var mixpanelInstance = response.detail[0].mixpanelInstance;
      if (mixpanelInstance && !Vue.prototype.$hhMixpanel) {
        Vue.prototype.$hhMixpanel = mixpanelInstance;
        mixpanelInstance.addRouterAutoTracking(this.$router);
        api.addInterceptors(mixpanelInstance);
      }
    },
    onHHComponentError(error) {
      this.showFooter = false;
      this.setIsLoading(false);
    }
  }
};
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 1s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>

<style>
html {
  height: 100%;
  box-sizing: border-box;
}
*,
*:before,
*:after {
  box-sizing: inherit;
}
.app-body {
  position: relative;
  margin: 0;
  padding-bottom: 60px;
  min-height: 100%;
}
.app-footer {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 60px;
  line-height: 60px;
}
.app-footer p {
  max-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue